import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchSessions } from "../../../actions/mine_craft/sessionsActions";

import PageLayout from '../_partials/PageLayout';
import ListTable from "./_partials/_ListTable";
import PageHeader from "../../../componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import './style.scss';

const LIMIT = 42;

export interface PropsInterface {
  appId: 1 | 2;
}

const Sessions = ({ appId }: PropsInterface) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const { pathname }    = useLocation();

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        app_id: appId,
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT,
        show_addons: true
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    dispatch(fetchSessions(params));
  }, [searchParams, appId, pathname, currentPage, dispatch]);

  return (
    <PageLayout className='v-sessions'>
      <PageHeader title='Sessions' />

      <div className='v-container-fluid'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            orderBy={{
              defaultKey: 'id',
              items: [
                { name: 'Created at', key: 'id' },
              ]
            }}
          />
        </Wrapper>

        <ListTable />
      </div>
    </PageLayout>
  );
}

export default Sessions;
